import gql from "graphql-tag";

export const MutationUpdateTherapist = gql(`
mutation(
    $id: ID!
    $firstName: String
    $lastName: String
    $birthday: String
    $mobile: String
    $gender: GENDER
    $address: String
    $city: String
    $state: String
    $country: String
    $updated: String
) {
    updateTherapist(input: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        birthday: $birthday
        mobile: $mobile
        gender: $gender
        address: $address
        city: $city
        state: $state
        country: $country
        updated: $updated
    }) {
        id
    	firstName
    	lastName
    	birthday
    	email
    	mobile
    	gender
    	address
    	city
        state
        country
    	created
    	updated
    }
}`);

// My Profile
export const QueryGetTherapist = gql(`
query($id: ID!) {
    getTherapist(id: $id) {
        firstName
    	lastName
    	birthday
    	email
    	mobile
    	gender
    	address
    	city
        state
        country
        status
    	created
        updated
    }
}`);

// Dashboard
export const QueryAllInfoTherapist = gql(`
query($id: ID!) {
    getTherapist(id: $id) {
        firstName
        lastName
        birthday
        email
        mobile
        gender
        address
        city
        state
        country
        created
        updated
        assessments {
            items {
                assessmentId
                analysis {
                    items {
                        analysisId
                    }
                }
            }
        }
    }
}`);


export const QueryGetPayments = gql(`
query getTherapist(
    $id: ID!
){
    getTherapist(id: $id){
        firstName
        lastName
        birthday
        email
        mobile
        gender
        address
        city
        state
        country
        status
        payments {
            items {
                payment_id
                plan_id
                amount
                tax
                total
                currency
                start_date
                end_date
                status
                created
                updated
            }
        }
        created
        updated
    }
}`);


export const MutationCreateTherapist = gql(`
mutation(
    $id: ID!
    $adminId: String!
    $firstName: String!
    $lastName: String!
    $birthday: String
    $email: String
    $mobile: String
    $gender: GENDER
    $address: String
    $city: String
    $state: String
    $country: String
    $status: Int        
    $created: String
    $updated: String
){
    createTherapist(input: {
        id: $id,
        adminId: $adminId,
        firstName: $firstName,
        lastName: $lastName,
        birthday: $birthday,
        email: $email,
        mobile: $mobile,
        gender: $gender,
        address: $address,
        city: $city,
        state: $state,
        country: $country,
        status: $status,        
        created: $created,
        updated: $updated
    }){
        id
        adminId
        firstName
        lastName
        birthday
        email
        mobile
        gender
        address
        city
        state
        country
        status      
        created
        updated
    }
}`);

export const QueryGetClinicsList = gql(`
query listClinics(
    $parentId: String!
){
    listClinics(parentId: $parentId) {
        items {
            id
            firstName
            lastName
            birthday
            email
            mobile
            gender
            address
            city
            state
            country
            status
            created
            updated
        }
    }
}`);